
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import SearchPopup from "./components/SearchPopup.vue";
import Cashier from "./components/Cashier.vue";
import Goods from "./components/Goods.vue";
import Category from "./components/Category.vue";
import {
  getCheckAccountsHead,
  getPaymentStatement,
  getGoodsStatement,
  getCategoryStatement,
} from "@/api/shouyin";
import getDate from "@/views/company/getDate";

@Component({
  components: { SearchPopup, Cashier, Goods, Category },
})
export class ReconciliationDetails extends Vue {
  @Getter companyId!: string;
  customDateText = "时间范围";
  active = 0; // 0收银对账 1商品对账 2类别对账
  searchRes = null;
  accountData = null; // 账号数据
  cashierBillData = null; // 收银对账数据
  goodsBillData = null; // 1商品对账数据
  categoryBillData = null; // 类别对账数据

  @Watch("active")
  onActiveChange() {
    // 获取数据
    this.getData();
  }

  @Watch("searchRes")
  onSearchResChange() {
    // 重置数据
    this.accountData = null;
    this.cashierBillData = null;
    this.goodsBillData = null;
    this.categoryBillData = null;
    // 获取数据
    this.getData();
  }

  mounted() {
    // 默认显示今天
    const days = getDate.getToday();
    let { starttime, endtime } = days;
    const startVal1 = starttime.split("-"); // 2025-01-01转[2025, 01, 01]
    const endVal1 = endtime.split("-");
    starttime = `${starttime} 00:00`; // 2025-01-01加上时分
    endtime = `${endtime} 23:59`;
    const { getNowTimeText } = this.$refs.searchPopupRef as any;
    this.searchRes = {
      label: this.customDateText,
      value: 0,
      // 回显
      startVal1,
      startVal2: ["00", "00"],
      endVal1,
      endVal2: ["23", "59"],
      // 传参
      starttime,
      endtime,
      // 显示
      nowTimeText: getNowTimeText(starttime, endtime),
    };
  }

  onSearchConfirm(res) {
    this.searchRes = res;
  }

  // 获取数据
  getData() {
    const { starttime, endtime } = this.searchRes;
    if (starttime && endtime) {
      const apiMap = {
        0: getPaymentStatement,
        1: getGoodsStatement,
        2: getCategoryStatement,
      };

      const dataKeyMap = {
        0: "cashierBillData",
        1: "goodsBillData",
        2: "categoryBillData",
      };
      const dataKey = dataKeyMap[this.active];
      if (this[dataKey]) return; // 已经获取过数据
      const api = apiMap[this.active];
      const params = {
        storeId: this.companyId,
        queryTimeBegin: `${starttime}:00`,
        queryTimeEnd: `${endtime}:59`,
      };
      !this.accountData &&
        getCheckAccountsHead(params).then((res) => {
          this.accountData = res.data;
        });
      api(params).then((res) => {
        this[dataKey] = res.data;
      });
    }
  }
}
export default ReconciliationDetails;
